import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deletePackage } from "../../api/apiPackages";
import parseError from "../../utils/parseError";

const useDeletePackage = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deletePkg,
        isPending: isDelete,
    } = useMutation({
        mutationFn: deletePackage,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["packages"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete package");
        },
    });

    return {
        deletePkg,
        isDelete,
    };
};

export default useDeletePackage;
